module.exports = __webpack_public_path__ + "img/chest-ecto-mesomorph-male.c7743e6f.svg";